import { useTranslation } from 'react-i18next';
import React from 'react'
// ANTD
import { Col, Row } from 'antd'
import { DetailsContainer } from 'Components/shared/details-container';

const EmergencyContact = ({
    driverDetails,
}) => {

    const { t } = useTranslation();
    const emergencyInfo = [
        {
            label:t("label.name"),
            value:driverDetails?.emergencyContactName
        },
        {
            label:t("label.relationship"),
            value:driverDetails?.relationship
        },
        {
            label:t("label.contactNo"),
            value: driverDetails?.emergencyContactNo?.dialCode ? `+${driverDetails?.emergencyContactNo?.dialCode} ${driverDetails?.emergencyContactNo?.number}` : '-',
        },
    ]

    return (
        <>
            <DetailsContainer
                listOfData={emergencyInfo}
            />
        </>
    )
}

export default EmergencyContact
